export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4827.991a6528.jpg";